import { useCallback } from "react";
import useU2000AxiosAuthenticated from "../../../u2000Core/axios/U2000UseAxiosAuthenticated";
import {
  doGetDocumentPdfFileArrayBuffer,
  type U3140DocumentLogicalUnit,
} from "../../U3140PdfAnnotationsService";

/**
 * Chargement du binaire PDF pour l’éditeur (variante `original`, sans aplat des annotations).
 */
export function useU3140PdfDocumentBuffer(documentLogicalUnit: U3140DocumentLogicalUnit) {
  const axios = useU2000AxiosAuthenticated();

  const loadOriginalPdfBuffer = useCallback(
    async (documentId: string): Promise<ArrayBuffer> => {
      return doGetDocumentPdfFileArrayBuffer(axios, documentId, "original", documentLogicalUnit);
    },
    [axios, documentLogicalUnit]
  );

  return { loadOriginalPdfBuffer };
}
